
<template>
    <v-snackbar v-model="stocksnackbar" :timeout="timeout" class="mb-10">
        <div v-for="(resp, i) in cartStatusResponse" :key="i">
            {{ resp }}
        </div>
        <template v-slot:actions>
            <v-btn color="blue" variant="text" @click="closeStocksnackbar">
                Close
            </v-btn>
        </template>
    </v-snackbar>
    <v-layout>
        <v-footer class="bg-primary">
            <v-row justify="center" no-gutters>
                <v-col class="text-center mt-4 d-none d-md-block d-md-block d-lg-block d-xl-block d-xxl-block" cols="12">

                    <v-btn color="white" variant="text" class="mx-2" rounded="xl" href="/">
                        HOME
                    </v-btn>

                    <v-btn color="white" variant="text" class="mx-2" rounded="xl" href="https://www.sigmafarmersmarket.com">
                        ABOUT US
                    </v-btn>

                    <v-btn color="white" variant="text" class="mx-2" rounded="xl" href="https://www.sigmafarmersmarket.com/partner-with-us/">
                        <!-- PRIVACY POLICY -->
                        Partner with us
                    </v-btn>

                    <v-btn color="white" variant="text" class="mx-2" rounded="xl" href="https://www.sigmafarmersmarket.com/contact-us/">
                        <!-- TERMS OF SERVICE -->
                        Contact Us
                    </v-btn>

                    <!--<v-btn v-for="link in links" :key="link" color="white" variant="text" class="mx-2" rounded="xl">
                        {{ link }}
                    </v-btn>-->
                </v-col>

                <v-col class="text-center mt-4 d-block d-md-none d-md-none d-lg-none d-xl-none d-xxl-none" cols="12">

                    <v-btn color="white" variant="text" class="footer-text" rounded="xl" href="/">
                        HOME
                    </v-btn>

                    <v-btn color="white" variant="text" rounded="xl" href="https://www.sigmafarmersmarket.com" class="footer-text">
                        ABOUT US
                    </v-btn>

                    <v-btn color="white" variant="text" rounded="xl" class="footer-text" href="https://www.sigmafarmersmarket.com/partner-with-us/">
                        <!-- PRIVACY POLICY -->
                        Partner with us
                    </v-btn>

                    <v-btn color="white" variant="text" rounded="xl" class="footer-text" href="https://www.sigmafarmersmarket.com/contact-us/">
                        <!-- TERMS OF SERVICE -->
                        Contact Us
                    </v-btn>

                </v-col>
                <v-col class="text-center mt-4 mb-5" cols="12">
                        <v-btn class="mx-4" icon="mdi-facebook"  href="https://www.facebook.com/people/Sigma-Farmers-Market/100091489702147/" variant="text" color="white"></v-btn>
                        <v-btn class="mx-4" icon="mdi-linkedin"  href="https://www.linkedin.com/in/kumaragurumanickavasagam/" variant="text" color="white"></v-btn>
                        <v-btn class="mx-4" icon="mdi-youtube"  href="https://www.youtube.com/@SigmaFarmersMarket" variant="text" color="white"></v-btn>
                        <v-btn class="mx-4" icon="mdi-instagram"  href="https://www.instagram.com/sigmafarmersmarket/" variant="text" color="white"></v-btn>
                </v-col>
                <v-divider class="mt-3 border-opacity-25" color="white"></v-divider>
                <v-col class="text-right mt-4 text-white footer-text" cols="12">
                    © {{ new Date().getFullYear() }} Sigma.. All Rights Reserved. Developed By AGT
                </v-col>
            </v-row>
        </v-footer>
        <!--<v-footer class="bg-primary text-center d-flex flex-column">
            <div>
                <v-btn v-for="icon in icons" :key="icon" class="mx-4" :icon="icon" variant="text"></v-btn>
            </div>
            <div>
                {{ new Date().getFullYear() }} — <strong>Sigmafarmersmarket</strong>
            </div>
        </v-footer>-->
    </v-layout>
</template>


<style>
.footer-text {
    font-size: 13px !important;
}
</style>
<script>
import { mapGetters, mapMutations } from "vuex";
export default {
    name: 'AppFooter',
    data: () => ({

        links: [
            'Home',
            'About Us',
            'Team',
            'Services',
            'Blog',
            'Contact Us',
        ],
        stocksnackbar: false,
        timeout: 2000,
    }),
    computed: {
        ...mapGetters([
            "getCartStatus",
            "getCartResponse",
        ]),
        cartStatusResponse: function () {
            return this.getCartResponse;
        }
    },
    created() {
        this.$store.subscribe((mutation) => {
            if (mutation.type === "cartError") {
                this.stocksnackbar = true;
            }
        });
    },
    methods: {
        ...mapMutations([
            'authUpdate', // map `this.increment()` to `this.$store.commit('increment')`
        ]),
        closeStocksnackbar() {
            this.stocksnackbar = false;
        }
    },
}
</script>